/* Instafeed legacy shim — prevents "feed is not defined" without changing app or IDs */
window.feed = window.feed || { run: function(){}, parse: function(){}, options: {} };

var myInterval = null;

window.addEventListener('DOMContentLoaded', function() {

/**
 * Function to wrap iframes with a specified class based on the presence of certain keywords in their src attribute.
 * @param {string[]} keywords - Array of keywords to look for in the iframe src attribute.
 * @param {string} wrapperClass - The CSS class to apply to the wrapping element.
 */
function wrapIframesBySrc(keywords, wrapperClass) {
  // Create a selector based on the keywords
  const selectors = keywords.map(keyword => `iframe[src*="${keyword}"]`).join(',');

  // Find all iframes that match the selector
  const iframes = document.querySelectorAll(selectors);

  // Wrap each iframe with a div that has the specified class
  iframes.forEach(iframe => {
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });
}

// Usage example: Wrap YouTube and Vimeo iframes with 'video-wrapper' class
wrapIframesBySrc(['youtube.com/embed', 'player.vimeo'], 'video-wrapper');


  
   const bodyElement = document.querySelector('body');
    let cartQtyObserver;

    const startObservingCartQty = function() {
        const cartQtyElement = document.querySelector('.cart-drawer__item-qty');
        
        if (cartQtyElement) {
            cartQtyObserver = new MutationObserver(function(mutationsList, observer) {
                for(const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        const qtyText = cartQtyElement.innerHTML;
                        const qty = qtyText.match(/\d+/) ? qtyText.match(/\d+/)[0] : '0';
                        
                        // Select all .header-count elements and update each
                        document.querySelectorAll('.header-count').forEach(headerCountElement => {
                            headerCountElement.innerHTML = qty;
                        });
                    }
                }
            });

            const config = { attributes: false, childList: true, subtree: true, characterData: true };
            cartQtyObserver.observe(cartQtyElement, config);
        } else {
            console.error('cart-drawer__item-qty element not found');
        }
    };

    // Body observer remains the same...
    const bodyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const bodyClassList = bodyElement.classList;
                if (bodyClassList.contains('js-drawer-open-cart')) {
                    startObservingCartQty();
                } else {
                    // Optionally stop observing cartQtyElement if needed
                    // stopObservingCartQty();
                }
            }
        });
    });

    bodyObserver.observe(bodyElement, {
        attributes: true,
        attributeFilter: ['class']
    });
  
  setTimeout(function() {
    englishProductTitleGrid();
  }, 5000); // Delay of 5 seconds
  
});

function englishProductTitleGrid() {
  let cutString = '|';
  let productGridItems = document.querySelectorAll('.product-grid-item__title');

  productGridItems.forEach(function(productGridItem) {
    if (productGridItem.textContent.includes(cutString)) {
      let stringArray = productGridItem.textContent.split(cutString);
      productGridItem.textContent = stringArray[0];
      let engTitle = document.createElement('span');
      engTitle.className = 'product-card__title--eng';
      engTitle.textContent = stringArray[1];
      productGridItem.appendChild(engTitle);
    }
  });
}

/* === SAFE INIT: run when jQuery is available (no timers to break) === */
(function waitForjQueryAndRun() {
  function runWithJQ($) {
    const productPage = {
      englishProductTitle: () => {
        const cutString = '|';
        $('.product__title').each(function (_k, v) {
          if ($(v).text().includes(cutString)) {
            const stringArray = $(v).text().split(cutString);
            $(this)
              .text(stringArray[0])
              .append(`<span class="product-card__title--eng">${stringArray[1]}</span>`);
          }
        });
      },

      descriptionTop: () => {
        const $target = $('.description_top');
        $target.find('.js-usp-clone').remove();
        if ($('.template-product .product-single__description.rte section.top').length) {
          const $clone = $('.product-single__description.rte section.top')
            .clone()
            .addClass('js-usp-clone');
          $clone.find('li').each(function () {
            const $li = $(this);
            $li.find('img.orange-bullets-img').remove();
            $li.prepend('<img class="orange-bullets-img" src="https://cdn.shopify.com/s/files/1/0505/4500/0617/files/checked.svg?v=1618220685" alt="">');
          });
          $target.prepend($clone);
        }
      },

      newDescriptionTop: () => {
        const $target = $('.description_top');
        $target.find('.js-usp-clone').remove();
        if ($('.template-product .custom-block-content section.top').length) {
          const $clone = $('.custom-block-content section.top')
            .clone()
            .addClass('js-usp-clone');
          $clone.find('li').each(function () {
            const $li = $(this);
            $li.find('img.orange-bullets-img').remove();
            $li.prepend('<img class="orange-bullets-img" src="https://cdn.shopify.com/s/files/1/0505/4500/0617/files/checked.svg?v=1618220685" alt="">');
          });
          $target.prepend($clone);
        }
      },

      run: () => {
        productPage.englishProductTitle();
        if ($('.template-product .custom-block-content section.top').length) {
          productPage.newDescriptionTop();
        } else {
          productPage.descriptionTop();
        }
      }
    };

    const cart = {
      init: () => {
        const cutString = '|';
        $('.template-cart .cart__product-title').each(function (_k, v) {
          if ($(v).text().includes(cutString)) {
            const stringArray = $(v).text().split(cutString);
            $(this)
              .text(stringArray[0])
              .append(`<span class="cart__title--eng">${stringArray[1]}</span>`);
          }
        });
      },
      run: () => cart.init()
    };

    $(function () {
      productPage.run();
      cart.run();
    });
  }

  if (window.jQuery && typeof window.jQuery === 'function') {
    runWithJQ(window.jQuery);
  } else {
    (function check() {
      if (window.jQuery && typeof window.jQuery === 'function') {
        return runWithJQ(window.jQuery);
      }
      requestAnimationFrame(check);
    })();
  }
})();

/* HERO 3 — clone countdown into delivery line on mobile (robust) */
(function(){
  var MOBILE_MAX = 767;

  function $1(s){ return document.querySelector(s); }
  function delivery(){ return $1('.delivery-information'); }
  function source(){
  // Try multiple theme/app variants, incl. your underscore version
  return $1('.variant__countdown') ||
         $1('[data-remaining-wrapper]') ||
         $1('.inventory_countdown') ||   // <-- added
         $1('.inventory-countdown')  ||  // hyphen variant
         $1('.inventory__message');      // message fallback
}


  function ensureCloneContainer(deliv){
    var span = deliv.querySelector('.inline-countdown');
    if (!span){
      span = document.createElement('span');
      span.className = 'inline-countdown';
      deliv.insertBefore(span, deliv.firstChild); // before "Livraison prévue -"
    }
    return span;
  }

  function makeCloneFrom(src){
    // Clone node so we keep its internal spans/icons, etc.
    var clone = src.cloneNode(true);
    clone.classList.add('is-clone');
    // Remove ids to avoid duplicates
    clone.removeAttribute('id');
    // Optional: strip aria-live to avoid duplicate announcements
    clone.removeAttribute('aria-live');
    return clone;
  }

  function visibleText(el){
    if (!el) return '';
    var t = (el.innerText || el.textContent || '').replace(/\s+/g,' ').trim();
    return t;
  }

  function update(){
    var deliv = delivery();
    var src   = source();
    var isMobile = window.innerWidth <= MOBILE_MAX;
if (deliv) deliv.classList.add('hero3-row');

    if (!deliv){
      document.body.classList.remove('hero3-inline-active');
      return;
    }

    // Always ensure container exists
    var container = ensureCloneContainer(deliv);

    // If we have a source with some visible text, clone it
    var text = visibleText(src);
    if (isMobile && src && text){
      var fresh = makeCloneFrom(src);

      // Replace any previous clone content
      container.innerHTML = '';
      container.appendChild(fresh);

      // Activate inline mode: show clone, hide originals (via CSS)
      document.body.classList.add('hero3-inline-active');
    } else {
      // No valid source or not mobile: deactivate and clear clone
      container.innerHTML = '';
      document.body.classList.remove('hero3-inline-active');
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    update();

    // Re-run on resize
    window.addEventListener('resize', function(){ update(); });

    // If the source is inserted/updated later, refresh the clone
    var attachObserver = function(){
      var src = source();
      if (!src) return false;
      var mo = new MutationObserver(update);
      mo.observe(src, {childList:true, subtree:true, characterData:true, attributes:true});
      return true;
    };

    // Try now; if not found yet, retry briefly
    if (!attachObserver()){
      var tries = 0, timer = setInterval(function(){
        if (attachObserver()){ clearInterval(timer); update(); }
        if (++tries > 40){ clearInterval(timer); }
      }, 100);
    }
  });
})();
